type numberOrNothing = number | null | undefined;

/**
 *
 * @param {string} formattedTimeAndSeconds
 * @return {numberOrNothing}
 */
export const getMinutes = (formattedTimeAndSeconds: string | null): numberOrNothing => {
  if (formattedTimeAndSeconds) {
    return Number(formattedTimeAndSeconds.split(':')[0]);
  }
  return 0;
};

/**
 * will return current time seconds if not found any in HH:SS format
 * @param {string} formattedTimeAndSeconds
 * @return {numberOrNothing}
 */
export const getSeconds = (formattedTimeAndSeconds: string | null): numberOrNothing => {
  if (formattedTimeAndSeconds) {
    const parts = formattedTimeAndSeconds.split(':');
    if (parts.length === 2) {
      return Number(parts[1]);
    }
  }
  return 0;
};

/**
 *
 * @param {numberOrNothing} time
 * @param {numberOrNothing} seconds
 * @return {string | null}
 */
export const getFormattedEventTime = (time: numberOrNothing, seconds: numberOrNothing): string | null => {
  if (time || time === 0) {
    const minutes = time ? time : 0;
    const secs = seconds ? (seconds <= 9 ? '0' + seconds : seconds) : '00';
    return `${minutes}:${secs}`;
  }
  return null;
};
